import ExtendableError from '../lib/ExtendableError';


export class InvalidSearchError extends ExtendableError {
    constructor (message, search) {
        const params = JSON.stringify(search.serialize());
        super(message, { params });
    }
    name = 'InvalidSearchError';
}
